import React from 'react'
import NotificationComponent from '../../components/Profile/Notifications'

function NotificationsPage () {
  return  <NotificationComponent/>
}
export default NotificationsPage